/*
 * Copyright (c) 2020.
 * Simon
 */

import {DOMAIN_NOTIFY_EMAIL_DETAIL_SUCCESS, DOMAIN_NOTIFY_EMAIL_LIST_SUCCESS} from "../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const DomainNotifyEmailsReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case DOMAIN_NOTIFY_EMAIL_LIST_SUCCESS: {
            const notifies = (action.payload.data && action.payload.data.data) || [];
            const next = {...state};

            notifies.forEach((notify) => {
                const id = notify._id;
                if (!id) return;

                if (notify.notify_type === 'collection') {
                    next[id] = {...notify, email: 'encrypted'};
                } else {
                    next[id] = notify;
                }
            });

            return next;
        }

        case DOMAIN_NOTIFY_EMAIL_DETAIL_SUCCESS: {
            const emailData = action.payload.data;
            const detailId = emailData._id || emailData.id;
            if (!detailId) return state;

            return {
                ...state,
                [detailId]: emailData,
            };
        }

        default:
            return state;
    }
};

export {DomainNotifyEmailsReducer};
